export default __webpack_public_path__ + "static/media/gamification-loot-box-midnight.161b6499.png";